export enum ReportBuilderTab {
  ALL_REPORTS = 'All Reports',
  STARRED = 'Starred',
  BUILT_IN_REPORTS = 'Built In Reports',
}
